(function () {
    'use strict';

    angular
        .module('app')
        .controller('UserExportController', UserExportController);

    UserExportController.$inject = ['$state',];

    function UserExportController($state) {
        // var vm = this;

        activate();

        function activate() {
            // Run on load
            if ($state && $state.current && $state.current.name === 'userExport') {
                $state.go('userExport.list');
            }
        }
    }
})();